import { createContext, useContext } from "react";

export interface LayoutAncestry {
  readonly nodeId: number;
  readonly ancestorIds?: readonly number[];
}

export const LayoutAncestryContext = createContext<LayoutAncestry | null>(null);

export function useLayoutAncestry(): LayoutAncestry | null {
  return useContext(LayoutAncestryContext);
}
